import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
import { NeonButton } from './NeonButton';
import { XCircleIcon, CheckCircleIcon, ArrowRightIcon, RocketIcon, GiftIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
export function ClosingSection() {
  return <SectionWrapper className="pb-32" data-id="element-128">
      <div className="text-center mb-10" data-id="element-129">
        <h2 className="text-2xl md:text-4xl text-white font-mono mb-3" data-id="element-130">
          Tienes{' '}
          <span className="text-cyber-neon text-shadow-neon" data-id="element-131">dos caminos</span>{' '}
          frente a ti:
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-132">
        <div className="bg-cyber-black border border-cyber-red/30 rounded-xl p-6 relative overflow-hidden opacity-70" data-id="element-133">
          <div className="absolute top-0 left-0 w-full h-1 bg-cyber-red/50" data-id="element-134"></div>
          <div className="flex items-center gap-3 mb-4" data-id="element-135">
            <XCircleIcon className="w-7 h-7 text-cyber-red" data-id="element-136" />
            <h3 className="text-xl font-mono font-bold text-gray-400" data-id="element-137">
              Camino A
            </h3>
          </div>
          <p className="text-gray-500 text-sm" data-id="element-138">
            Cierras esta página y sigues siendo el que se esconde en el baño, el
            que pierde oportunidades y el que se siente solo en medio de la
            multitud.
          </p>
        </div>

        <div className="bg-cyber-dark border-2 border-cyber-neon rounded-xl p-6 relative overflow-hidden shadow-neon" data-id="element-139">
          <div className="absolute top-0 left-0 w-full h-1 bg-cyber-neon shadow-neon" data-id="element-140"></div>
          <div className="flex items-center gap-3 mb-4" data-id="element-141">
            <CheckCircleIcon className="w-7 h-7 text-cyber-neon" data-id="element-142" />
            <h3 className="text-xl font-mono font-bold text-white" data-id="element-143">Camino B</h3>
          </div>
          <p className="text-gray-300 text-sm mb-4" data-id="element-144">
            Inviertes <strong className="text-cyber-neon" data-id="element-145">$9.99 hoy</strong> (el
            precio de una pizza) y empiezas a hackear tu realidad social para
            convertirte en la persona que siempre quisiste ser.
          </p>
          <NeonButton href={CHECKOUT_URL} size="md" fullWidth data-id="element-146">
            ELEGIR CAMINO B <ArrowRightIcon className="w-4 h-4" data-id="element-147" />
          </NeonButton>
          <span className="flex items-center gap-1.5 text-[10px] font-mono bg-cyber-neon/5 border border-cyber-neon/30 rounded-full px-3 py-1 mt-2 shadow-[0_0_8px_rgba(57,255,20,0.1)]" data-id="element-148">
            <GiftIcon className="w-3 h-3 text-cyber-neon animate-pulse" data-id="element-149" />
            <span className="text-gray-300" data-id="element-150">
              + 2 Bonos <strong className="text-cyber-neon" data-id="element-151">GRATIS</strong>
            </span>
          </span>
          <button onClick={() => document.getElementById('bonos')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-[10px] text-cyber-neon font-mono underline underline-offset-2 hover:text-white transition-colors mt-1" data-id="element-152">
            Leer más
          </button>
        </div>
      </div>

      {/* FINAL MEGA CTA */}
      <motion.div animate={{
      boxShadow: ['0 0 20px rgba(57,255,20,0.3)', '0 0 60px rgba(57,255,20,0.5)', '0 0 20px rgba(57,255,20,0.3)']
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} className="max-w-3xl mx-auto bg-cyber-dark border-2 border-cyber-neon rounded-2xl p-6 md:p-8 text-center" data-id="element-153">
        <RocketIcon className="w-10 h-10 text-cyber-neon mx-auto mb-3" data-id="element-154" />
        <p className="text-gray-400 text-sm mb-4 font-mono" data-id="element-155">
          Última oportunidad — La oferta termina cuando el contador llegue a
          00:00
        </p>
        <NeonButton href={CHECKOUT_URL} size="lg" fullWidth className="text-lg md:text-2xl py-6 md:py-7" data-id="element-156">
          🚀 SÍ, QUIERO HACKEAR MI ANSIEDAD — $9.99{' '}
          <ArrowRightIcon className="w-6 h-6 md:w-7 md:h-7" data-id="element-157" />
        </NeonButton>
        <div className="flex flex-col items-center gap-1 mt-3" data-id="element-158">
          <div className="flex items-center justify-center gap-1.5 text-xs font-mono bg-cyber-neon/5 border border-cyber-neon/30 rounded-full px-4 py-1.5 shadow-[0_0_10px_rgba(57,255,20,0.12)]" data-id="element-159">
            <GiftIcon className="w-3.5 h-3.5 text-cyber-neon animate-pulse" data-id="element-160" />
            <span className="text-gray-300" data-id="element-161">
              + 2 Bonos <strong className="text-cyber-neon" data-id="element-162">GRATIS</strong>{' '}
              incluidos <span className="text-gray-500" data-id="element-163">(valor $47)</span>
            </span>
          </div>
          <div className="bg-cyber-dark/60 border border-cyber-neon/15 rounded-lg p-2.5 space-y-1.5 max-w-lg mx-auto" data-id="element-164">
            <div className="flex items-start gap-2" data-id="element-165">
              <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-166" />
              <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-167">
                <span className="text-gray-300 font-bold" data-id="element-168">Bonus 1:</span>{' '}
                Scripts de Supervivencia en Citas — qué decir para que nunca
                haya silencios incómodos.
                <span className="ml-1 text-gray-500 line-through" data-id="element-169">$25</span>
                <span className="ml-1 text-cyber-neon font-bold" data-id="element-170">GRATIS</span>
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-171">
              <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-172" />
              <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-173">
                <span className="text-gray-300 font-bold" data-id="element-174">Bonus 2:</span>{' '}
                Templates de Texto Irresistibles — para que nunca más te dejen
                en "visto" en WhatsApp.
                <span className="ml-1 text-gray-500 line-through" data-id="element-175">$22</span>
                <span className="ml-1 text-cyber-neon font-bold" data-id="element-176">GRATIS</span>
              </p>
            </div>
            <div className="border-t border-cyber-neon/20 pt-1.5 mt-1" data-id="element-177">
              <p className="text-[11px] font-mono text-cyber-neon font-bold text-center" data-id="element-178">
                Te ahorras $47 USD en bonos de regalo
              </p>
            </div>
          </div>
          <button onClick={() => document.getElementById('bonos')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-[11px] text-cyber-neon font-mono underline underline-offset-2 hover:text-white transition-colors" data-id="element-179">
            Leer más
          </button>
        </div>
        <p className="text-gray-600 text-[10px] font-mono mt-2" data-id="element-180">
          Pago seguro · Acceso inmediato · Garantía 7 días · Sin riesgo
        </p>
      </motion.div>
    </SectionWrapper>;
}